var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVideo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Video_Call",
    "data-name": "Video Call",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 27,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1172",
    "data-name": "Ellipse 1172",
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#00aeef"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video-camera-svgrepo-com",
    transform: "translate(15 19.975)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8031",
    "data-name": "Path 8031",
    d: "M17,8H6a2.946,2.946,0,0,0-3,3V21a2.946,2.946,0,0,0,3,3H17a2.946,2.946,0,0,0,3-3V11A2.946,2.946,0,0,0,17,8Z",
    transform: "translate(-3 -7.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8032",
    "data-name": "Path 8032",
    d: "M28.5,8.1a.908.908,0,0,0-1,0l-5,3a1.05,1.05,0,0,0-.5.9v8a1.05,1.05,0,0,0,.5.9l5,3a.749.749,0,0,0,.5.1.9.9,0,0,0,.5-.1A1.05,1.05,0,0,0,29,23V9A1.05,1.05,0,0,0,28.5,8.1Z",
    transform: "translate(-3 -7.95)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon-video.532f4be28efeab47bf0040a9a923df27.svg";
export { ForwardRef as ReactComponent };